
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 18H1M14 18H6m-3 0V3.125c0-.564.21-1.104.586-1.503A1.942 1.942 0 015 1h10c.53 0 1.04.224 1.414.622.375.399.586.94.586 1.503V18H3zM12 6V5M12 10V9M12 14v-1M8 6V5M8 10V9M8 14v-1","stroke":"#667080","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    